// extracted by mini-css-extract-plugin
module.exports = {"root":"tweet-not-found_root__m8vmp"};